import { toCSS, toJSON } from 'css-convert-json';

export function emailIsValid(email: string) {
  if (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      email,
    )
  ) {
    return true;
  }
  return false;
}

export function phoneNumberIsValid(phoneNumber: string) {
  // This regex checks for a valid phone number format (e.g., +1234567890, 123-456-7890, *909, *2003, etc.)
  if (
    /^(\+?\d{1,3}[-\s]?)?(\(?\d{2,4}\)?[-\s]?)?(\d{3,4}[-\s]?\d{4}|[*]\d{3,4})$/.test(
      phoneNumber,
    )
  ) {
    return true;
  }
  return false;
}

export function fullNameIsValid(fullName: string) {
  if (/^([\w]{3,})+\s+([\w\s]{3,})+$/.test(fullName)) {
    return true;
  }
  return false;
}

export function passwordIsValid(password: string) {
  if (password.length >= 8) {
    return true;
  }
  return false;
}

export function isValidUrl(url: string) {
  try {
    new URL(url);
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?' +
        '(\\/[-a-z\\d%_.~+{}\\|]*)*' + // allow curly braces in the path
        '(\\?[;&a-z\\d%_.~+=\\-{}\\|]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i',
    );
    return !!pattern.test(url);
  } catch (_) {
    return false;
  }
}

export function formFieldEmailValidator(
  email?: string,
  required: boolean = false,
):
  | {
      status?: 'error' | 'success';
      text?: string;
    }
  | undefined {
  if (!email) {
    if (required) {
      return { status: 'error', text: 'required' };
    }

    return undefined;
  }
  return emailIsValid(email)
    ? undefined
    : { status: 'error', text: 'invalid email' };
}

export function formFieldPhoneNumberValidator(
  phoneNumber?: string,
  required: boolean = false,
):
  | {
      status?: 'error' | 'success';
      text?: string;
    }
  | undefined {
  if (!phoneNumber) {
    if (required) {
      return { status: 'error', text: 'required' };
    }

    return undefined;
  }
  return phoneNumberIsValid(phoneNumber)
    ? undefined
    : { status: 'error', text: 'invalid phone number' };
}

export function formFieldUrlValidator(
  url?: string,
  required: boolean = false,
):
  | {
      status?: 'error' | 'success';
      text?: string;
    }
  | undefined {
  if (!url) {
    if (required) {
      return { status: 'error', text: 'required' };
    }

    return undefined;
  }
  return isValidUrl(url) ? undefined : { status: 'error', text: 'invalid url' };
}

export function mergeFromFieldValidators(
  mode: 'allPassing' | 'atLeastOnePassing' = 'atLeastOnePassing',
  ...validatorResults: Array<
    | {
        status?: 'error' | 'success';
        text?: string;
      }
    | undefined
  >
): { status?: 'error' | 'success'; text?: string } | undefined {
  const errors = validatorResults.filter(
    (result) => result?.status === 'error',
  );
  const successes = validatorResults.filter(
    (result) => !result || result?.status === 'success',
  );

  if (mode === 'allPassing') {
    if (errors.length > 0) {
      return { status: 'error', text: errors.map((e) => e?.text).join(', ') };
    }
    return { status: 'success' };
  }

  if (mode === 'atLeastOnePassing') {
    if (successes.length > 0) {
      return { status: 'success' };
    }
    return { status: 'error', text: errors.map((e) => e?.text).join(', ') };
  }

  return undefined;
}

export function formFieldRequiredValidator(value?: string):
  | {
      status?: 'error' | 'success';
      text?: string;
    }
  | undefined {
  if (!value?.trim()) {
    return { status: 'error', text: 'required' };
  }
  return undefined;
}

export function isValidCss(css: string): boolean {
  const cleanNewButtonCSS = css
    .replaceAll(' ', '')
    .replaceAll(/\n+/g, '\n')
    .trim();
  const cleanValidCss = toCSS(toJSON(css))
    .trim()
    .replaceAll(' ', '')
    .replaceAll(/\n+/g, '\n');
  return cleanNewButtonCSS === cleanValidCss;
}
